export const checkUserProfiling = (resource_id) => {
  switch (resource_id) {
    case "care":
      return "C";
    default:
      return "R";
  }
};
